import { Injectable } from '@angular/core';
import { Router, NavigationStart, Event } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouteInterceptorService {
  constructor(private router: Router) {
    this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationStart =>
            event instanceof NavigationStart
        )
      )
      .subscribe((event) => {
        const match = event.url.match(/^\/tenantIdDeepLink\/([^\/]+)(\/.*)?$/);

        if (match) {
          const localTenantId = localStorage.getItem('activeTenantId');
          const tenantId = match[1];

          if (localTenantId?.toLowerCase() != tenantId.toLowerCase()) {
            const remainingPath = match[2] || '/';

            localStorage.setItem('activeTenantId', tenantId);
            this.router.navigate(
              ['/tenantIdDeepLinkError', tenantId, remainingPath],
              {
                replaceUrl: true,
              }
            );
          } else {
            const regex = /\/tenantIdDeepLink\/[^/]+(\/.*)/;
            const matchPath = event.url.match(regex);

            const cleanedPath = matchPath?.[1] || '/';

            this.router.navigateByUrl(cleanedPath, { replaceUrl: true });
          }
        }
      });
  }
}
